export enum WhiteSpaceMode {
  Replace = 'replace',
  Collapse = 'collapse',
}
